import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError, pipe } from "rxjs";
import {
  map,
  catchError,
  retryWhen,
  delay,
  take,
  tap,
  finalize,
} from "rxjs/operators";
import { Injectable } from "@angular/core";
import { AuthenticationCheckService } from "../auth/authentication-check.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ToastClientService } from "../toast/toast-client.service";
@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  /**
   * Whenever calling Api this interceptor will inject AUTH_Token and enable loader
   */
  constructor(
    private auth: AuthenticationCheckService,
    private ngxService: NgxUiLoaderService,
    private toast: ToastClientService,
  ) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    //Authentication by setting header with token value
    let disableloader = request.headers.get("skip");
    let token = this.auth.getAuthToken();
    const isLoginRequest = request.url.includes("login/login");
    //
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: token,
        },
      });
    }

    if (!request.headers.has("Content-Type")) {
      request = request.clone({
        setHeaders: {
          // 'content-type': 'application/json'
        },
      });
    }

    request = request.clone({
      headers: request.headers.set("Accept", "application/json"),
    });
    if (disableloader != "true") {
      this.loaderStart();
    }

    if (request.url.includes("is_loader=yes")) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        if (
          event instanceof HttpResponse &&
          !isLoginRequest &&
          event.body &&
          event.body.status_code === 401
        ) {
          this.handleUnauthorized(
            event.body.message || "Session expired. Please login again.",
          );
        }
      }),
      // retryWhen(err=>{
      //     let retries =1;
      //     return err.pipe(
      //         delay(1000),
      //         tap(()=>{
      //
      //         }),
      //         map(error=>{
      //             if(retries++ === 3){
      //                 return error
      //             }
      //             return error
      //         })
      //     )
      // }),
      catchError((error: HttpErrorResponse) => {
        let errorMessage = "";
        let toasterMessage = "";

        if (error.error instanceof ErrorEvent) {
          // client-side error
          errorMessage = `Error: ${error.error.message}`;
          toasterMessage = error.error.message;
        } else {
          // server-side error
          const errorBody = error.error;
          toasterMessage =
            (errorBody && (errorBody.detail || errorBody.message)) ||
            error.message ||
            "Something went wrong";
          errorMessage = `Error Code: ${error.status}\nMessage: ${toasterMessage}`;
        }

        if (error.status === 401 && !isLoginRequest) {
          this.handleUnauthorized("Session expired. Please login again.");
          return throwError(errorMessage);
        }

        console.log(errorMessage);
        console.log(toasterMessage);
        this.toast.Error(toasterMessage.split('"').join(""));
        try {
          const normalizedMessage = toasterMessage.toLowerCase().split('"').join("");
          if (
            normalizedMessage == "no access to this module" ||
            normalizedMessage == "unauthorized user access!!" ||
            normalizedMessage == "access token is not set permission denied!" ||
            normalizedMessage == "something wrong with request." ||
            normalizedMessage == "trying to access array offset on value of type bool"
          ) {
            this.handleUnauthorized();
          }
        } catch (error) {}
        this.loaderDismiss();
        return throwError(errorMessage);
      }),
      finalize(() => {
        this.loaderDismiss();
      }),
    );
  }

  private handleUnauthorized(message?: string) {
    if (message) {
      this.toast.Error(message);
    }
    this.loaderDismiss();
    this.auth.logout();
  }

  loaderStart() {
    try {
      this.ngxService.start();
    } catch (error) {}
  }
  loaderDismiss() {
    try {
      // this.loadingCntr.dismiss();
      this.ngxService.stop();
    } catch (error) {}
  }
}
